import { ensureGuestToken, hasRecoverableGuestSession, GuestRecoveryUnavailableError } from "@/lib/guest-session"

async function verifyUser() {
  const accountToken = await ensureGuestToken()
  if (!accountToken) {
    if (hasRecoverableGuestSession()) throw new GuestRecoveryUnavailableError()
    window.location.href = "/profile/auth"
    throw new Error("No guest session")
  }
  return { accountToken }
}

export default verifyUser
